// extracted by mini-css-extract-plugin
module.exports = {"all":"e_Oq","accent":"e_Pq"};